import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/createMonthGoal',
    baseurl2:'/api/swyl/v1',
    //创单月目标列表
    page(query){
        return http({
            url: this.baseurl+'/userDailyTargetLQHY/getUserDailyTargetPage',
            method: 'post',
            params: query
        });
    },
    selectById(query){
        return http({
            url: this.baseurl+'/userDailyTargetLQHY/selectById',
            method: 'post',
            params: query
        });
    },
    saveOrUpdate(query){
        return http({
            url: this.baseurl+'/userDailyTargetLQHY/saveOrUpdateUserDailyTargetDate',
            method: 'post',
            params: query
        });
    },
    tzGrade(query){
        return http({
            url: this.baseurl+'/userDailyTargetLQHY/adjustScore',
            method: 'post',
            data: query
        });
    },
    getLianqun(query){
        return http({
            url: this.baseurl+'/userDailyTargetLQHY/getLianQun',
            method: 'post',
            params: query
        });
    },
    getAllLianqun(){
        return http({
            url: this.baseurl+'/userDailyTargetLQHY/getAllLianQun',
            method: 'post'
        });
    },
    getLianQunByUser(query){
        return http({
            url: this.baseurl+'/userDailyTargetLQHY/getLianQunByUser',
            method: 'post',
            params: query
        });
    },
}
